"use client";

import JSONViewer from "@/components/ui/json-viewer";
import { PDFViewer } from "@/components/ui/pdf-viewer";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useMeasure } from "@uidotdev/usehooks";
import { isPdf, isImage } from "@/utils/file-type";
import { ContextPanel } from "@/app/report/components";
import { CurrencyValue } from "@/components/ui/currency-value";
import dayjs from "dayjs";
import { Combobox, CurrencyCode } from "@/components/ui";
import { Book, Globe, Search, Share, X } from "lucide-react";
import { ComboboxOption } from "@headlessui/react";
import clsx from "clsx";
import { useMemo, useState } from "react";
import { useAppStore } from "@/store/appStore";

const InvoiceContextPanel = () => {
  const [ref, { width, height }] = useMeasure();
  //const queryClient = useQueryClient()
  const invoice = useAppStore((s) => s.selectedInvoice);

  /*
  const [queryClient] = useState(() => new QueryClient())
  
  const { mutate: removeInvoiceMutation} = useMutation({
    mutationFn: async (invoiceId: string) => {
      return await fetch(`/api/invoice/remove`, {
        method: 'POST',
        body: JSON.stringify({ invoiceId }),
      });
    },
    onSuccess: async (response) => {
      const data = await response.json();
      console.log('removeInvoiceMutation onSuccess', data);

      if(user && user.data && data && data.invoice && data.invoice.id) {
        queryClient.setQueryData(['user'], 
          {
              ...user.data, 
              selectedReport: {
                ...user.data.selectedReport,
                invoices: user.data.selectedReport?.invoices.filter(invoice => invoice.id !== data.invoice.id)
              }
          } as UserWithCompanies)
      } else {
        console.error('removeInvoiceMutation onSuccess failed', data);
      }
    }
    
  });

  
  TODO: Move these to ContextPanel component

  const invoiceCardSelectHandler = (invoice: InvoiceExtended) => {
    console.log('invoiceCardSelectHandler', invoice);
    setSelectedInvoice(invoice);
  }
  const removeInvoiceHandler = async (invoiceId: string) => {
    console.log('removeInvoiceHandler', invoiceId);
    setInvoices(invoices.filter(invoice => invoice.id !== invoiceId))
    removeInvoiceMutation(invoiceId);
  }
    */

  const selectTransaction = (transactionId: string) => {
    console.log("selected transaction", transactionId);
  };

  return (
    <ContextPanel
      header={{
        image: {
          type: "logo",
          label: invoice?.seller.companyName || invoice?.seller.name || "",
          source: invoice?.seller.corporateWebsiteURL || undefined,
          fallback: invoice?.seller.companyName
            ? invoice.seller.companyName.slice(0, 2).toUpperCase()
            : "?",
        },
        title: invoice?.invoiceId || "",
        subtitle: (
          <>
            <CurrencyValue
              size={"S"}
              amount={
                invoice && invoice.totalAmount ? invoice.totalAmount : undefined
              }
              currency={
                invoice && invoice.currency
                  ? (invoice.currency as CurrencyCode)
                  : undefined
              }
            />
            <div className="text-xs text-gray-500">
              {invoice && dayjs(invoice.issueDate).format("MMM Do ")}
              {invoice &&
                invoice.issueDate &&
                dayjs(invoice.issueDate).format("h:mma")}
            </div>
          </>
        ),
      }}
      tabs={[
        {
          label: "Invoice",
          value: "invoice",
          sections: [
            {
              title: "Invoice",
              children: (
                <ScrollArea ref={ref}>
                  {invoice &&
                    isPdf(invoice.documentUrl) &&
                    invoice.documentUrl && (
                      <PDFViewer
                        width={width || undefined}
                        height={height || undefined}
                        documentUrl={invoice.documentUrl}
                      ></PDFViewer>
                    )}
                  {invoice &&
                    isImage(invoice.documentUrl) &&
                    invoice.documentUrl && (
                      <img
                        className="border border-gray-300"
                        src={invoice.documentUrl}
                        alt={invoice.invoiceId}
                        width={width || undefined}
                        height={height || undefined}
                      />
                    )}
                </ScrollArea>
              ),
            },
          ],
        },
        {
          label: "Details",
          value: "details",
          sections: [
            {
              title: "Status",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Transactions",
              children: (
                <Combobox
                  onChange={(event) => console.log("search", event)}
                  icon={<Search />}
                  //isLoading={isSearching ? 'Searching...' : undefined}
                  placeholder="Search by Transaction ID, Seller Name..."
                  items={
                    invoice
                      ? invoice.transactions?.map(
                          (
                            transaction: (typeof invoice.transactions)[number]
                          ) => ({
                            ...transaction,
                            title: transaction.id,
                            onClick: () => selectTransaction(transaction.id),
                          })
                        )
                      : []
                  }
                  customItem={(item) => (
                    <ComboboxOption
                      onClick={() => selectTransaction(item.id)}
                      value={item.id}
                      className={clsx(
                        "flex-col prose-paragraph-14-medium flex cursor-pointer select-none items-center gap-xs truncate whitespace-nowrap rounded-2xs px-xs py-xs text-foreground transition hover:bg-foreground hover:text-foreground focus:bg-foreground focus:text-foreground  aria-[current=page]:text-secondary aria-[current=page]:hover:bg-navigation_item-current_hover aria-[current=page]:hover:text-secondary aria-[current=page]:focus:bg-navigation_item-current_hover aria-[current=page]:focus:text-secondary aria-[current=page]:active:bg-navigation_item-current_focus aria-[current=page]:active:text-secondary ui-active:bg-foreground/20 ui-active:text-primary_hover ui-disabled:cursor-not-allowed ui-disabled:bg-primary ui-disabled:text-primary_disabled [&_svg]:size-5 [&_svg]:shrink-0",
                        "rounded-xs gap-xs p-sm cursor-pointer hover:bg-foreground/5 data-[focus]:bg-foreground/5 data-[focus]:text-primary_hover",
                        "hidden" in item && "hidden"
                      )}
                    >
                      <h3>{item.id}</h3>
                      {/**
                {item.seller ? <Logo url={item.seller.corporateWebsiteURL} shortName={item.seller.shortCompanyName} longName={item.seller.companyName} /> : null}
                {item.documentUrl ? <PDFViewer documentUrl={item.documentUrl} width={300} /> : null}
                */}
                    </ComboboxOption>
                  )}
                  query={undefined}
                />
              ),
            },
            {
              title: "Seller",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Buyer",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Purpose",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Issue Date",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Due Date",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Completion Date",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Settled Date",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Tags",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Notes",
              children: <div>{invoice?.status}</div>,
            },
            {
              title: "Data",
              children: <>{invoice && <JSONViewer data={invoice} />}</>,
            },
          ],
        },
        {
          label: "Actions",
          value: "actions",
          actions: [
            {
              icon: <Share size={16} />,
              label: "Share Invoice",
              onClick: () => console.log("Share Invoice"),
            },

            {
              icon: <Globe />,
              label: "Change Space",
              onClick: () => console.log("Change Space"),
            },

            {
              icon: <Book />,
              label: "Change to Statement",
              onClick: () => console.log("Change to Statement"),
            },

            {
              icon: <X />,
              label: "Remove Invoice",
              onClick: () => console.log("Remove Invoice"),
            },
          ],
        },
      ]}
    />
  );

  /*

    return <div  className="w-[450px] p-5 fixed top-[53px] right-0 bottom-0 bg-slate-50 border-l border-gray-200">
        <h2 className={`mb-3 text-center font-semibold`}>{invoice.invoiceId}</h2>
        <Tabs defaultValue="preview" className="w-full">

            <TabsList>
                <TabsTrigger value="preview">Preview</TabsTrigger>
                <TabsTrigger value="data">Data</TabsTrigger>
            </TabsList>
            
            <TabsContent value="preview">
                <ScrollArea ref={ref}>
                    {isPdf(invoice.documentUrl) && invoice.documentUrl &&
                        <PDFViewer width={width || undefined} height={height || undefined} documentUrl={invoice.documentUrl}></PDFViewer> }
                    {isImage(invoice.documentUrl) && invoice.documentUrl &&
                        <img className="border border-gray-300" src={invoice.documentUrl} alt={invoice.invoiceId} width={width || undefined} height={height || undefined} />}
                </ScrollArea>
            </TabsContent>

            <TabsContent value="data">
                <ScrollArea>
                    <JSONViewer data={invoice} />
                </ScrollArea>
            </TabsContent>

        </Tabs>

    </div>*/
};

export { InvoiceContextPanel };
